module.exports = __webpack_public_path__ + "img/Wp_2019.d7cdb315.png";